<template>
    <div class="home">
        <m-header/>
            <router-view/>
        <m-footer/>
        <div>
            <a-back-top/>
        </div>
    </div>
</template>

<script>
import MHeader from "@/components/MHeader.vue";
import MFooter from "@/components/MFooter2";

export default {
    name: 'Home',
    components: {
        MHeader,
        MFooter,
    },
    mounted() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    },
}
</script>

<style>
.page {
    width: 1280px;
    min-width: 1120px;
    max-width: 1600px;
    min-height: 300px;
    margin: 0 auto;
    color: #333333;
    position: relative;
    z-index: 5;
}

#components-back-top-demo-custom .ant-back-top {
    bottom: 100px;
}

#components-back-top-demo-custom .ant-back-top-inner {
    height: 40px;
    width: 40px;
    line-height: 40px;
    border-radius: 4px;
    background-color: #1088e9;
    color: #fff;
    text-align: center;
    font-size: 20px;
}

@media (max-width: 1000px) {
    .home{
        width: 100vw;
        overflow-x: hidden;
    }
    .page {
        width: 100%;
        box-sizing: border-box;
        min-width: 14.93rem;
        max-width: 21.33rem;
        min-height: 4.00rem;
        margin: 0;
        color: #333333;
        position: relative;
        z-index: 5;
    }

    #components-back-top-demo-custom .ant-back-top {
        bottom: 1.33rem;
    }

    #components-back-top-demo-custom .ant-back-top-inner {
        height: 0.53rem;
        width: 0.53rem;
        line-height: 0.53rem;
        border-radius: 0.05rem;
        background-color: #1088e9;
        color: #fff;
        text-align: center;
        font-size: 0.27rem;
    }

}
</style>
